module.exports = __webpack_public_path__ + "static/media/13d.94aad4e7.png";